import { apiErrorCodes } from 'consts/api/apiErrorCodes';
import { commonTexts, journalTexts } from 'consts/text';
import { getErrorMessageAndCode } from 'utils/errorHandlers/getErrorMessageAndCode';

export const journalChildEditDatesErrorParser: (error: unknown) => string = (error) => {
    const { code } = getErrorMessageAndCode(error);

    if (code === apiErrorCodes.CHILD_GROUP_JOURNAL_DATES_OVERLAP) {
        return journalTexts.journalDetails.common.children
            .childGroupJournalDatesOverlapErrorMessage;
    }

    if (code === apiErrorCodes.CHILD_JOURNAL_DATES_OUTSIDE_JOURNAL_DATES) {
        return journalTexts.journalDetails.common.children
            .childJournalDatesOutsideJournalDatesErrorMessage;
    }

    return commonTexts.errorMessages.actionExecution;
};
